import React, {
  useCallback, useContext, useEffect, useState,
} from 'react';
import {
  Avatar, Badge, Box, IconButton, Tooltip, Typography,
} from '@mui/material';
import cardIcon from 'Images/card_icon.svg';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { WithRolesComponent } from 'HOC/withRoles';
import ConfigContext from 'Shared/ConfigContext';
import { setProfile } from 'Shared/ConfigContext/Actions';
import UserContext from 'Shared/UserContext';
import { useHistory } from 'react-router-dom';
import Settings from './Settings';
import { getProfile } from './services';
import PanierDropDown from './PanierDropdown';

const UserSection = ({ setOpenModal, setOpenModalPwd }) => {
  const { dispatch: dispatchConfig, state: { profile, paniers } } = useContext(ConfigContext);
  const { state: { user } } = useContext(UserContext);
  const history = useHistory();

  const [anchorEl, setAnchorEl] = useState(null);
  const openCart = Boolean(anchorEl?.id === 'cart');

  const activePanierCount = paniers?.filter((p) => p.validated === 0).length || 0;

  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const onGetProfile = useCallback(async () => {
    dispatchConfig(setProfile({}));
    localStorage.removeItem('edge_profile');
    try {
      const data = await getProfile();
      localStorage.setItem('edge_profile', JSON.stringify(data));
      dispatchConfig(setProfile(data));
    } catch (e) {
      if (!e?.handled) console.error(e);
    }
  }, [dispatchConfig]);

  useEffect(() => {
    if (user.role === 'ROLE_CLIENT') {
      onGetProfile();
    }
  }, [user]);

  return (
    <>
      {/* Desktop: Cart + User box */}
      <Box
        sx={{
          height: '48px',
          width: '260px',
          background: '#F8FAFC',
          border: '1px solid #DEE5EE',
          borderRadius: '8px',
          display: { xs: 'none', md: 'flex' },
          alignItems: 'center',
          px: '12px',
          gap: '8px',
          flexShrink: 0,
        }}
      >
        <WithRolesComponent allowedRoles={['ROLE_CLIENT']}>
          <Tooltip title="Paniers">
            <IconButton
              size="small"
              onClick={handleMenu}
              id="cart"
              aria-describedby="cart-popover"
              disableFocusRipple
              sx={{ color: '#007BC6', p: '4px', '&.Mui-focusVisible': { backgroundColor: 'transparent' } }}
            >
              <Badge
                badgeContent={activePanierCount}
                color="primary"
                sx={{ '& .MuiBadge-badge': { fontSize: 10, minWidth: 16, height: 16 } }}
              >
                <img src={cardIcon} alt="panier" style={{ width: 22, height: 22, objectFit: 'contain' }} />
              </Badge>
            </IconButton>
          </Tooltip>
          <PanierDropDown open={openCart} handleClose={handleClose} anchorEl={anchorEl} />
          <Box
            sx={{
              width: '1px', height: '36px', background: '#DEE5EE', flexShrink: 0, ml: '10px',
            }}
          />
        </WithRolesComponent>

        <Box
          id="settings"
          onClick={handleMenu}
          sx={{
            display: 'flex', alignItems: 'center', gap: '2px', cursor: 'pointer', flex: 1, overflow: 'hidden', minWidth: 0,
          }}
        >
          <Avatar sx={{
            width: 30, height: 30, bgcolor: '#007BC6', fontSize: 12, flexShrink: 0, mr: '8px', ml: '4px',
          }}
          >
            {profile?.name?.[0]?.toUpperCase() || user?.username?.[0]?.toUpperCase() || 'U'}
          </Avatar>
          <Box sx={{ overflow: 'hidden', flex: 1 }}>
            <Typography sx={{
              fontSize: 13, fontWeight: 600, color: '#717182', lineHeight: 1.3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
            }}
            >
              {profile?.name || user?.username}
            </Typography>
            <Typography sx={{
              fontSize: 11, color: '#8F8F8F', lineHeight: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
            }}
            >
              {user?.username || ''}
            </Typography>
          </Box>
          <KeyboardArrowDownIcon
            sx={{
              color: '#8F8F8F', fontSize: 16, flexShrink: 0, mr: '6px',
            }}
          />
        </Box>

        <Settings
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          setOpenModalPwd={setOpenModalPwd}
          setOpenModal={setOpenModal}
        />
      </Box>

      {/* Mobile: Cart icon */}
      <Tooltip title="Paniers">
        <IconButton
          onClick={() => history.push('/cart')}
          sx={{ color: 'gray', display: { xs: 'flex', md: 'none' } }}
        >
          <img src={cardIcon} alt="panier" style={{ width: 22, height: 22, objectFit: 'contain' }} />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default UserSection;
